module.exports = __webpack_public_path__ + "img/broze-card.1f4ed5d4.png";